var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkHorizontal = function SvgLinkHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12a6 6 0 0 1 6-6h2a6 6 0 0 1 0 12h-.5a1 1 0 1 1 0-2h.5a4 4 0 0 0 0-8h-2a4 4 0 0 0-4 4 1 1 0 1 1-2 0ZM7 8a4 4 0 1 0 0 8h2a4 4 0 0 0 4-4 1 1 0 1 1 2 0 6 6 0 0 1-6 6H7A6 6 0 0 1 7 6h.5a1 1 0 0 1 0 2H7Z",
    fill: "#9E9E9E"
  })));
};
export { SvgLinkHorizontal as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkgMTJhNiA2IDAgMCAxIDYtNmgyYTYgNiAwIDAgMSAwIDEyaC0uNWExIDEgMCAxIDEgMC0yaC41YTQgNCAwIDAgMCAwLThoLTJhNCA0IDAgMCAwLTQgNCAxIDEgMCAxIDEtMiAwWk03IDhhNCA0IDAgMSAwIDAgOGgyYTQgNCAwIDAgMCA0LTQgMSAxIDAgMSAxIDIgMCA2IDYgMCAwIDEtNiA2SDdBNiA2IDAgMCAxIDcgNmguNWExIDEgMCAwIDEgMCAySDdaIiBmaWxsPSIjOUU5RTlFIi8+PC9zdmc+";